// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})


	function scrollAtTheStartOfSection(id){
		let sectionFromUrl = document.getElementById(id)
		if( sectionFromUrl ){
			sectionFromUrl.scrollIntoView({
				behavior: "smooth",
				block:"center"
			});
			};
		}
	   
	   
		let itemsNav = document.querySelectorAll('.privary-navigation .privary-navigation__item'); 

		itemsNav.forEach((item) => { 
			item.addEventListener("click", (e) => { 
				itemsNav.forEach((item) => {item.classList.remove('active-link-nav')});
				item.classList.add('active-link-nav'); 
				let anchor = item.querySelector('a'); 
				let idGetted = anchor.hash.substring(1) 
				if( idGetted ){ 
					e.preventDefault(); 
					scrollAtTheStartOfSection(idGetted); 
				} 
			}); 
		});



    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


	// Show more buttons intro content

	let toggleButton = document.getElementById("toggleButton");
	if(toggleButton) {
		toggleButton.addEventListener("click", () => {
			let para2 = document.getElementById('paragraph2');
			if (para2.classList.contains('show')) {
                para2.style.height = '0';
                para2.classList.remove('show');
                toggleButton.classList.remove('show');
            } else {
                para2.style.height = para2.scrollHeight + 'px';
                para2.classList.add('show');
                toggleButton.classList.add('show');
            }
		})
	}


	// --------- Navigation Triggers ---------

	let openMenu = document.getElementById("burgerMenu");
	if( openMenu ){
		openMenu.addEventListener("click", function() {
		document.querySelector(".js-navigation").classList.add("active");
		});
	}


	let closeMenu = document.querySelector(".close-menu");
	if(closeMenu){
		closeMenu.addEventListener("click", function() {
		document.querySelector(".js-navigation").classList.remove("active");
		});
	}

	let itemsClose = document.querySelectorAll(".js-navigation .navigation .inner ul li");
	if(itemsClose) {
		itemsClose.forEach( e => {
			e.addEventListener("click", () => {
				document.querySelector(".js-navigation").classList.remove("active");
			})
		});
	}


})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}